import { BorderlessStar } from 'components/Icons';
import React, { useCallback } from 'react';
import type { ToggleProps } from 'react-toggle';
import ReactToggle from 'react-toggle';
import styles from './Toggle.module.scss';

interface OwnProps {
  isLockedFeature?: boolean;
  onLockedFeatureClicked?: () => void;
}

const Toggle: React.FC<ToggleProps & OwnProps> = props => {
  const { isLockedFeature, onChange, onLockedFeatureClicked, ...rest } = props;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (isLockedFeature) {
        onLockedFeatureClicked?.();
      } else {
        onChange?.(e);
      }
    },
    [isLockedFeature, onLockedFeatureClicked, onChange]
  );

  if (isLockedFeature) {
    return (
      <div className={styles.container}>
        <BorderlessStar className={styles.lockedFeatureIcon} />
        <ReactToggle onChange={handleChange} {...rest} checked={false} />
      </div>
    );
  }

  return <ReactToggle onChange={handleChange} {...rest} />;
};

export default Toggle;
